module.exports = __webpack_public_path__ + "static/media/palang-family.b1e4e5dc.png";